/* eslint-disable */
import * as React from 'react';
import styled from 'styled-components';
import { __ } from 'react-i18n';
import { rem } from 'polished';
import { useState } from 'react';
import { Button } from '../General/Button';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { RangeFilter } from '../Category/RangeFilter';
import { InfoIcon } from '../InfoIcon/InfoIcon';
import { prop } from '../../../utilities';
import { BaseModal } from '../Modal/BaseModal';

interface Props {
  attribs: any;
  attribGroups: any;
  urlAttribsObj: any;
  lang: string;
  preloadCount?: number;
  onClose: () => void;
  onFilter: (activeAttribs, activeRangeAttribs) => void;
  onFilterCount: (activeAttribs, activeRangeAttribs) => void;
}

export function ParamsModal({
  attribGroups,
  attribs,
  urlAttribsObj,
  lang,
  preloadCount,
  onClose,
  onFilter,
  onFilterCount,
}: Props) {
  const [activeGroupId, setActiveGroupId] = useState(undefined);
  const [activeAttribs, setActiveAttribs] = useState({});
  const [activeRangeAttribs, setActiveRangeAttribs] = useState({});
  const [loadResultsTimeout, setLoadResultsTimeout] = useState(null);

  React.useEffect(() => {
    const activeAttribs = JSON.parse(
      JSON.stringify(prop(urlAttribsObj, 'attribs', {})),
    );
    const activeRangeAttribs = JSON.parse(
      JSON.stringify(prop(urlAttribsObj, 'rangeAttribs', {})),
    );

    setActiveAttribs(activeAttribs);
    setActiveRangeAttribs(activeRangeAttribs);
  }, []);

  if (activeGroupId === undefined && attribGroups?.length) {
    setActiveGroupId(attribGroups[0].group_id);
  }

  if (
    !attribGroups?.find(ag => ag.group_id === null) &&
    attribs &&
    Object.entries(attribs).filter(
      ([key, attrib]) => (attrib as any)?.attrib_data?.group_id === null,
    ).length
  ) {
    attribGroups?.push({
      group_id: null,
      group_name: __('Ostatné parametre'),
      group_sort: 9999,
    });
  }

  const attribsArray = Object.entries(attribs);
  attribsArray.sort((a, b) => {
    const aAttribData = prop(a[1], 'attrib_data');
    const bAttribData = prop(b[1], 'attrib_data');

    if (aAttribData?.type_id !== bAttribData?.type_id) {
      return aAttribData?.type_id - bAttribData?.type_id;
    }
    if (aAttribData?.attrib_sort !== bAttribData?.attrib_sort) {
      return aAttribData?.attrib_sort - bAttribData?.attrib_sort;
    }
    return aAttribData.attrib_id - bAttribData.attrib_id;
  });

  const updateFilterCount = (activeAttribs, activeRangeAttribs) => {
    const extendedTimeIntervalMs = 0;
    if (loadResultsTimeout) {
      clearTimeout(loadResultsTimeout);
    }

    const currentLoadResultsTimeout: any = setTimeout(async () => {
      onFilterCount(activeAttribs, activeRangeAttribs);
    }, extendedTimeIntervalMs);
    setLoadResultsTimeout(currentLoadResultsTimeout);
  };

  const toogleCheckboxType = (attribId: number, valueId: number) => {
    if (!activeAttribs[attribId]) {
      activeAttribs[attribId] = {
        values: [],
      };
    }

    if (activeAttribs[attribId].values.find(value => value == valueId)) {
      activeAttribs[attribId].values = activeAttribs[attribId].values.filter(
        value => value != valueId,
      );
    } else {
      activeAttribs[attribId].values.push(valueId);
    }
    setActiveAttribs({ ...activeAttribs });
    updateFilterCount(activeAttribs, activeRangeAttribs);
  };

  const updateRangeType = (attribId: number, min: number, max: number) => {
    const attrib = attribs[attribId];

    if (!activeRangeAttribs[attribId]) {
      activeRangeAttribs[attribId] = {
        min: attrib?.min,
        max: attrib?.max,
      };
    }

    activeRangeAttribs[attribId] = {
      min: min,
      max: max,
    };

    setActiveRangeAttribs(activeRangeAttribs);
    updateFilterCount(activeAttribs, activeRangeAttribs);
  };

  const cancelSelectedParams = () => {
    setActiveAttribs({});
    setActiveRangeAttribs({});
    onFilterCount({}, {});
  };

  const getAttribParameterFromAttribObj = (
    value: any,
    parameterName: string,
    lang?: string,
  ) => {
    if (lang && value && value.translations) {
      const langTranslation = value.translations.find(t => t.lang_id === lang);
      if (prop(langTranslation, parameterName)) {
        return prop(langTranslation, parameterName);
      }
    }
    return prop(value, parameterName);
  }

  const body = (
    <BodyWrapper>
      <LeftSide>
        {attribGroups?.map(attribGroup => {
          return (
            <GroupItem
              isActive={attribGroup.group_id === activeGroupId}
              onClick={() => setActiveGroupId(attribGroup.group_id)}
            >
              {' '}
              {attribGroup.group_name}{' '}
            </GroupItem>
          );
        })}
      </LeftSide>
      <RightSide>
        {attribGroups?.map(attribGroup => {
          return (
            <AttribsWrapper isActive={attribGroup.group_id === activeGroupId}>
              <AttribGroupName> {attribGroup.group_name} </AttribGroupName>
              {attribsArray
                .filter(([key, attrib]) => {
                  const anyAttrib: any = attrib;
                  return (
                    anyAttrib?.attrib_data?.group_id === attribGroup.group_id &&
                    ((anyAttrib.attrib_data.attrib_type === 'zakladny' &&
                      anyAttrib.values?.length) ||
                      anyAttrib.attrib_data.attrib_type !== 'zakladny')
                  );
                })
                .map(([key, attrib]) => {
                  const anyAttrib: any = attrib;

                  const activeMax = prop(
                    activeRangeAttribs[
                      prop(anyAttrib.attrib_data, 'attrib_id')
                    ],
                    'max',
                  );

                  const activeMin = prop(
                    activeRangeAttribs[
                      prop(anyAttrib.attrib_data, 'attrib_id')
                    ],
                    'min',
                  );

                  return (
                    <Attrib>
                      <AttribName>
                        {getAttribParameterFromAttribObj(
                          anyAttrib.attrib_data,
                          'attrib_name',
                          lang,
                        )}

                        <InfoIcon
                          infoDescription={getAttribParameterFromAttribObj(
                            anyAttrib.attrib_data,
                            'attrib_short_description',
                            lang,
                          )}
                        />
                      </AttribName>
                      <AttribValueWrapper>
                        {anyAttrib.attrib_data.attrib_type === 'zakladny' ? (
                          <BaseValuesWrapper>
                            {anyAttrib.values.map(value => {
                              const selected = activeAttribs[
                                value.info.attrib_id
                              ]?.values.find(
                                activeValue =>
                                  activeValue == value.info.value_id,
                              )
                                ? true
                                : false;

                              const attribLink = getAttribParameterFromAttribObj(
                                value.info,
                                'attrib_link',
                                lang,
                              );

                              const attribShortDescription = getAttribParameterFromAttribObj(
                                value.info,
                                'attrib_short_description',
                                lang,
                              );

                              return (
                                <div>
                                  <CheckBox
                                    key={'onlyAvailable'}
                                    name="onlyAvailable"
                                    label={
                                      getAttribParameterFromAttribObj(
                                        value.info,
                                        'attrib_value',
                                        lang,
                                      ) + ` (${value.filtered_doc_count})`
                                    }
                                    type={'checkbox'}
                                    selected={selected}
                                    disabled={
                                      value.filtered_doc_count === 0 &&
                                      !selected
                                    }
                                    onClick={() => {
                                      toogleCheckboxType(
                                        value.info.attrib_id,
                                        value.info.value_id,
                                      );
                                    }}
                                    infoLink={attribLink}
                                    infoDescription={attribShortDescription}
                                    width={18}
                                    height={18}
                                    fontSize={14}
                                  />
                                </div>
                              );
                            })}
                          </BaseValuesWrapper>
                        ) : anyAttrib.attrib_data.attrib_type === 'rozsah' ? (
                          <RangeValueWrapper>
                            <RangeFilter
                              handleFilterChange={(type, newData) => {
                                updateRangeType(
                                  newData.attribId,
                                  newData.min,
                                  newData.max,
                                );
                              }}
                              isOpen={true}
                              filterData={{
                                min: anyAttrib.min,
                                max: anyAttrib.max,
                                activeMax: activeMax || anyAttrib.max,
                                activeMin: activeMin || anyAttrib.min,
                                attribId: anyAttrib.attrib_data.attrib_id,
                              }}
                              unit={anyAttrib.attrib_data.attrib_unit}
                              inputHeight={40}
                              disabled={
                                (anyAttrib.filteredMin === undefined ||
                                  anyAttrib.filteredMax === undefined) &&
                                !activeMax &&
                                !activeMin
                              }
                            />
                          </RangeValueWrapper>
                        ) : (
                          <></>
                        )}
                      </AttribValueWrapper>
                    </Attrib>
                  );
                })}
            </AttribsWrapper>
          );
        })}
      </RightSide>
    </BodyWrapper>
  );

  const footer = (
    <Footer>
      <FooterLeft>
        <CancelSelectedText
          onClick={() => {
            cancelSelectedParams();
          }}
        >
          {' '}
          {__('Zrušiť vybrané parametre')}{' '}
        </CancelSelectedText>
      </FooterLeft>
      <FooterRight>
        <FooterButtonWhite onClick={() => onClose()}>
          {' '}
          {__('Zavrieť')}{' '}
        </FooterButtonWhite>
        <FooterButton
          onClick={() => {
            onFilter(activeAttribs, activeRangeAttribs);
          }}
        >
          {' '}
          {__('Zobraziť')} {preloadCount}{' '}
          {!preloadCount
            ? __('položky')
            : preloadCount === 1
            ? __('položku')
            : preloadCount >= 2 && preloadCount <= 4
            ? __('položky')
            : __('položiek')}{' '}
        </FooterButton>
      </FooterRight>
    </Footer>
  );

  return (
    <BaseModal
      body={body}
      footer={footer}
      enableCloseIcon={true}
      handleClose={() => {
        onClose();
      }}
      titleText={__('Všetky parametre')}
      enableOutsideClick={true}
      height="600px"
    />
  );
}

const BodyWrapper = styled.div`
  display: flex;
  height: 100%;
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f6f7fb;
`;

const RightSide = styled.div`
  padding-left: ${rem(40)};
  padding-right: ${rem(20)};
  padding-top: ${rem(20)};
  padding-bottom: ${rem(15)};
  width: 100%;
  overflow: auto;
`;

const GroupItem = styled.div<{
  isActive: boolean;
}>`
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.white : '#f6f7fb'};
  border-right: ${({ isActive }) => (isActive ? 'none' : 'px solid #efeff0')};
  border-bottom: 2px solid #efeff0;
  padding-right: ${rem(20)};
  padding-left: ${rem(20)};
  padding-top: ${rem(14)};
  padding-bottom: ${rem(14)};
  min-width: ${rem(200)};
  cursor: pointer;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: ${rem(30)};
  padding-right: ${rem(30)};
  padding-top: ${rem(15)};
  padding-bottom: ${rem(15)};
  color: ${({ theme }) => `${theme.colors.textPrimary}`};
`;

const FooterLeft = styled.div``;

const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(20)};
`;

const CancelSelectedText = styled.a`
  color: ${({ theme }) => `${theme.colors.textPrimary}`};
  text-decoration: underline;
`;

const FooterButton = styled(Button)`
  margin: 0 auto;
  min-height: ${rem(40)};
`;

const FooterButtonWhite = styled(FooterButton)`
  background-color: white;
  color: ${({ theme }) => `${theme.colors.primary}`};
  border: 2px solid ${({ theme }) => `${theme.colors.primary}`};
  font-weight: bold;
`;

const AttribsWrapper = styled.div<{
  isActive: boolean;
}>`
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  flex-direction: column;
`;

const Attrib = styled.div`
  margin-top: ${rem(30)};
`;

const AttribName = styled.div`
  padding: 0;
  margin: 0;
  font-size: ${rem(18)};
  display: flex;
  align-items: center;
`;

const AttribValueWrapper = styled.div`
  margin-top: ${rem(16)};
`;

const BaseValuesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(5)};
`;

const RangeValueWrapper = styled.div`
  margin-left: ${rem(15)};
  margin-right: ${rem(15)};
  width: 50%;
`;

const AttribGroupName = styled.div`
  font-size: ${rem(24)};
`;
